export default {
  title: 'Parcels',
  pending_tab: 'Pending',
  collected_tab: 'Collected',
  tracking_number: 'Tracking #',
  carrier: 'Carrier',
  received_at: 'Received',
  collected_at: 'Collected',
  no_pending: 'No pending parcels',
  no_collected: 'No collected parcels',
  description: 'Description',
}
